var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',[_c('h4',{staticClass:"page-title"},[_vm._v("세무지식 수정")]),_c('edit-knowhow-form')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }